const name = 'Flip';
const properties = {
    schema: {},
};
const powerMap = {
    soft: { ease: 'linear' },
    medium: { ease: 'quintInOut' },
    hard: { ease: 'backOut' },
};
const directionMap = {
    vertical: 'rotationX',
    horizontal: 'rotationY',
};
/**
 * Flip animation object
 */
function animate(kit, elements, duration, delay, { direction = 'horizontal', power, easing = 'linear', ...params } = {}) {
    const sequence = kit.sequence(params);
    const rotationAxis = directionMap[direction];
    const ease = typeof power !== 'undefined' ? powerMap[power].ease : easing;
    sequence
        .add(kit.engine.set(elements, {
        transformPerspective: 800,
    }))
        .add(kit.animate('BaseRotate3D', elements, duration, 0, {
        to: { [rotationAxis]: `360deg` },
        ease,
    }))
        .add(kit.animate('BaseNone', elements, delay, 0)); // add repeat delay
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=flip.js.map